/*

Controller file for Leases

*/
import { browserHistory } from 'react-router'
import { server } from '../../engine/server'
import { modal } from '../../utilities/modal'

var AdminUserAccounts = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getUsers: function(callback) {
		var self = this;
		var url = "admin/user/management/accounts";
		// #  Send to server object for processing
		var data = self.server.getData(url,null,true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getUser: function(id, callback) {
		var self = this;
		var url = "admin/user/" + id;
		// #  Send to server object for processing
		var data = self.server.getData(url,null,true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    },
    loginAsUser: function(userId, callback) {
        var self = this;
        var url = "admin/user/login/" + userId;
		var data = self.server.getData(url, null, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to log you into user.", "danger", "top", "center");
		});
	},
	enableUser: function(userId, callback) {
        var self = this;
        var url = "admin/user/enable/" + userId;
		var data = self.server.getData(url, null, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to enable user.", "danger", "top", "center");
		});
	},
	disableUser: function(userId, callback) {
        var self = this;
        var url = "admin/user/disable/" + userId;
		var data = self.server.getData(url, null, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to disable user.", "danger", "top", "center");
		});
	},
	activatePaymentCollection: function(userId, callback) {
        var self = this;
        var url = "admin/user/collect/enable/" + userId;
		var data = self.server.getData(url, null, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to activate payment collection.", "danger", "top", "center");
		});
	},
	disablePaymentCollection: function(userId, callback) {
        var self = this;
        var url = "admin/user/collect/disable/" + userId;
		var data = self.server.getData(url, null, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to disable payment collection.", "danger", "top", "center");
		});
	},
	updateUser: function(data, callback) {
        var self = this;
        var url = "admin/user/" + data.user.id;
		var data = self.server.getData(url, data, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to update user.", "danger", "top", "center");
		});
	},
	saveNewUser: function(data, callback) {
        var self = this;
        var url = "admin/user/0"; //TODO: change to the right route
		var data = self.server.getData(url, data, true, 'POST');
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to save user.", "danger", "top", "center");
		});
	},
	deleteUser: function(userId, callback) {
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this user account. All data associated will be deleted and you will not be able to recover.","Yes, Delete");
		jQuery(".move-on").on('click',function() {
			var url = "admin/user/" + userId; //TODO: change to the right route
			var data = self.server.getData(url,null,true, "DELETE");
			data
			.done(function(response){
				if (response.status == 1 || response.status == 2) {
				}
				else if (response.data.error != null) {
					modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
				}
				else {
					modal.resetBackDrop();
					modal.showSuccess('User Deleted!', 'User account has been removed.');
					jQuery(".move-on").on('click',function() {
						browserHistory.goBack();
					});
				}
			})
			.fail(function(e){
				modal.showInfo("Unable to delete this user account.", "danger", "top", "center");
			});
		});
	},
	getInactiveUsers: function(callback) {
		var self = this;
		var url = "admin/users/inactive";
		var data = self.server.getData(url,null,true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	getNewManagers: function(callback) {
		var self = this;
		var url = "admin/users/latest";
		var data = self.server.getData(url,null,true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
	exportUsersData: function(planType, callback) {
		var self = this;
		var url = "admin/users/export/" + planType;
		var data = self.server.getFile(url, null, true, 'POST');
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
	},
});

export let adminUserAccounts = new AdminUserAccounts();


// WEBPACK FOOTER //
// app/core/controllers/Admin/AdminUserAccounts.js